import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { IRootState } from "../../../store";
import DispatchProps from "../../../utils/DispatchProps";
import PageTitle from "../../PageTitle";
import ApiService from "../../ApiService";
import H from "history";
import TenantSummary from "../../../models/tenants/TenantSummary";
import TenantList from "../../tenants/TenantList";
import LoadingPage from "../../LoadingPage";
import Table, { TableColumn } from "../../Table";

const APP_ROLE_ASSIGNMENT_COLUMNS: TableColumn[] = [
    { title: "Permission Name", extraDetail: "name", propertyPath: "name", enableSort: true, flex: 1 },
    { title: "Permission Id", extraDetail: "appRoleId", propertyPath: "appRoleAssignment.appRoleId", enableSort: true, flex: 1 },
    { title: "Resource", extraDetail: "resourceDisplayName", propertyPath: "appRoleAssignment.resourceDisplayName", enableSort: true, flex: 1 },
    { title: "App Name", extraDetail: "principalDisplayName", propertyPath: "appRoleAssignment.principalDisplayName", enableSort: true, flex: 1 },
    { title: "Created at", extraDetail: "createdDateTime", propertyPath: "appRoleAssignment.createdDateTime", type: "date", enableSort: true, flex: 1 },
];

const DELEGATED_APP_PERMISSION_COLUMNS: TableColumn[] = [
    { title: "Permission Name", extraDetail: "scope", propertyPath: "scope", enableSort: true, flex: 1 },
    { title: "Resource Name", extraDetail: "resourceName", propertyPath: "resourceName", enableSort: true, flex: 1 },
    { title: "Resource Id", extraDetail: "resourceId", propertyPath: "resourceId", enableSort: true, flex: 1 }
];

interface TenantAppPermissionsPageProps {
    tenantId: string;

    apiService: ApiService;
}

interface TenantAppPermissionsPageState {
    tenant?: TenantSummary | null;
    appRoleAssignments?: any[];
    delegatedAppPermissions?: any[];
}

class TenantAppPermissionsPage extends Component<TenantAppPermissionsPageProps & DispatchProps, TenantAppPermissionsPageState> {
    static displayName = TenantAppPermissionsPage.name;

    constructor(props: TenantAppPermissionsPageProps & DispatchProps) {
        super(props);

        this.state = {
            tenant: undefined,
            appRoleAssignments: undefined
        }
    }

    async componentDidMount() {

        const tenant = await this.props.apiService.getTenantAdmin(this.props.tenantId);
        const appRoleAssignments = await this.props.apiService.getAppRoleAssignmentsForTenantAdmin(this.props.tenantId);
        const delegatedAppPermissions = await this.props.apiService.getDelegatedAppPermissionsForTenantAdmin(this.props.tenantId);

        this.setState({
            tenant,
            appRoleAssignments,
            delegatedAppPermissions
        });
    }

    async componentDidUpdate(prevProps: Readonly<TenantAppPermissionsPageProps & DispatchProps>, prevState: TenantAppPermissionsPageState): Promise<void> {
    }
    render() {

        if (this.state.tenant === undefined || this.state.appRoleAssignments === undefined || this.state.delegatedAppPermissions === undefined) {
            return <LoadingPage />;
        }

        const tenantFriendlyName = this.state.tenant?.tenantName ?? this.props.tenantId;

        const title = `App Permissions for ${tenantFriendlyName}`

        return (
            <Fragment>
                <PageTitle title={title} />

                <TenantList title={tenantFriendlyName} items={this.state.tenant ? [this.state.tenant] : undefined} enableRowLinks={false} />

                <Table
                    title={title}
                    columns={APP_ROLE_ASSIGNMENT_COLUMNS}
                    enableSort={true}
                    defaultSortColumnPath={'name'}
                    items={this.state.appRoleAssignments}
                    className={"cdb-table--enable-hover"}
                />

                <Table
                    title={`Delegated App Permissions for ${tenantFriendlyName}`}
                    columns={DELEGATED_APP_PERMISSION_COLUMNS}
                    enableSort={true}
                    defaultSortColumnPath={'scope'}
                    items={this.state.delegatedAppPermissions}
                    className={"cdb-table--enable-hover"}
                />
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: { match: any, history: H.History }): TenantAppPermissionsPageProps => {
        return {
            tenantId: ownProps.match.params.tenantId,
            apiService: state.auth.apiService,
        };
    }
)(TenantAppPermissionsPage)